export function chatMatchesSearch(query: string, fields: readonly (string | null)[]): boolean {
  const needle = query.trim().toLocaleLowerCase('pt-BR');
  if (needle.length === 0) {
    return true;
  }
  return fields.some((field) => field?.toLocaleLowerCase('pt-BR').includes(needle) === true);
}
